import {ITestheftvarianten, TFach, TKursAbschluss, TKursNiveau} from "../Interfaces";
import Veraportal from "./../Veraportal";
import Modal from "./../Modal";
import Utilities from "./../Utilities";
import {IGruppenDB} from "../InterfacesDB";
import VeraApi from "./../VeraApi";
import Tooltip from '../Tooltip';

export default class KursAnpassenModal extends Modal {
    private aktuelleGruppe: IGruppenDB = null;

    public constructor(veraportal: Veraportal, aktuelleGruppeId: number = null) {
        super(veraportal);

        this.aktuelleGruppe = this._veraportal.gruppenliste.filter((g) => {
            return g.gruppe_id === aktuelleGruppeId
        })[0] ?? null;
    }

    protected override modalMain() {
        this.mainHTML = `
        <main>
            
            ${(this.aktuelleGruppe === null) ? `
                <p>Bei <i>Kursen</i> handelt es sich um <b>fachspezifische</b> Gruppen von Schüler, die auf selbem Niveau
                in diesem Fach gemeinsam unterrichtet werden.<br/>
                Zum Anlegen eines <i>Kurses</i> wählen Sie bitte eine Bezeichnung, sowie das Fach
                und ggf. weitere Eigenschaften des <i>Kurses</i>. Möchten sie Eigenschaften nachträglich ändern, können Sie neben einem
                Kurs auf das Zahnrad-Icon klicken.<br/>
                Schüler können Sie <b>anschließend in der <i>Schüler-Verwaltung</i> den <i>Kursen</i> zuordnen</b>.</p>
            ` : `
                <p>Bei <i>Kursen</i> handelt es sich um <b>fachspezifische</b> Gruppen von Schüler, die auf selbem Niveau
                in diesem Fach gemeinsam unterrichtet werden.<br/>
                Die Anpassungen, welche Sie hier in den Kurseigenschaften vornehmen, wirken sich auf alle Schüler aus,
                die dem Kurs zugeordnet sind.</p>
            `}
            <div class="kurs-anlegen">
                <div class="feld active">
                    <label for="kamodal-bezeichnung"
                    data-tooltip="${Tooltip.html`
                        <p><strong>Kursbezeichnung</strong></p>
                        <p>Wählen Sie eine Bezeichnung, die während des ${this._veraportal.sessionvariablen.projekt.bezeichnung}-Durchgangs nachvollziehbar bleibt. Doppelte Bezeichnungen und exotische Sonderzeichen sind nicht zulässig.</p>
                    `}">
                        Bezeichnung:<br/>
                        <input type="text" id="kamodal-bezeichnung" size="20" maxlength="16" value="${(this.aktuelleGruppe !== null) ? this.aktuelleGruppe.bezeichnung : ''}"/>
                    </label>
                </div>
                
                <div class="feld active">
                    <label for="kamodal-fach">Fach:</label>
                    <select id="kamodal-fach">
                        <option value="-" selected>Fach wählen!</option>
                        ${(this._veraportal.sessionvariablen.schule.teilnahme_mathematik !== 0) ? `<option value="ma">Mathematik</option>` : ``}
                        ${(this._veraportal.sessionvariablen.schule.teilnahme_deutsch !== 0) ? `<option value="de">Deutsch</option>` : ``}
                        ${(this._veraportal.sessionvariablen.schule.teilnahme_englisch !== 0) ? `<option value="en">Englisch</option>` : ``}
                        ${(this._veraportal.sessionvariablen.schule.teilnahme_franzoesisch !== 0) ? `<option value="fr">Französisch</option>` : ``}
                    </select>
                </div>
                
                
                <div class="feld ${(this._veraportal.sessionvariablen.schule.land === 'nw' && ['GE', 'HS', 'FS'].includes(this._veraportal.sessionvariablen.schule.schulform)) ? `active` : ``}">
                    <label for="kamodal-niveau">Kursniveau:</label>
                    <select id="kamodal-niveau" disabled="disabled">
                        <option value="-" selected>Kursniveau wählen!</option>
                        <option value="GK">Grundkurs</option>
                        <option value="EK">Erweiterungskurs</option>
                        <option value="KD">Keine Diff. (wie Stammklasse)</option>
                    </select>
                </div>
                
                <div class="feld ${(this._veraportal.sessionvariablen.schule.land === 'nw' && ['HS', 'FS'].includes(this._veraportal.sessionvariablen.schule.schulform)) ? `active` : ``}">
                    <label for="kamodal-abschluss">Angestrebter Abschluss:</label>
                    <select id="kamodal-abschluss" disabled="disabled">
                        <option value="-" selected>-</option>
                        <option value="EESA">EESA</option>
                        <option value="MSA">MSA</option>
                        <option value="I">Keine Diff.</option>
                    </select>
                </div>
               
                <div class="feld active">
                    <label for="kamodal-testheft">Testheft:</label>
                    <select class="testheft" id="kamodal-testheft" disabled="disabled">
                        <option value="-" selected>Testheft wählen!</option>
                    </select>
               </div>
            </div>
        </main>
        `;
    }

    override async init() {
        await this._veraportal.lifecycleLeave(); // mit Öffnung des Fensters Schüler übertragen

        // Modal Überschrift und Buttonbeschriftung ändern, wenn Editierung statt neu anlegen
        if (this.aktuelleGruppe !== null) {
            document.querySelector(`#modal-kurs-anpassen > article > header > h3`)
                .innerHTML = `Kurseigenschaften von '${this.aktuelleGruppe.bezeichnung}' ändern
                <button id="kamodal-gruppe-loeschen-btn">
                    <svg role="graphics-symbol">
                        <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#trash"/>
                    </svg>
                Kurs löschen
                </button>`;

            document.querySelector(`#modal-kurs-anpassen > article > footer > button.submit`)
                .innerHTML = `Speichern`;
        }

        // Eingabebeschraenkungen Textfelder
        document.querySelector(`#kamodal-bezeichnung`).addEventListener('keyup', (evt) => {
            Utilities.forceKeys(evt.target as HTMLInputElement, 'A-Za-z0-9äÄüÜöÖß\\-\\_\\ \\.', false, true);
        });

        const modalFachState = () => {
            const isVera5 = this._veraportal.sessionvariablen.projekt.weiche === 'vera5';

            // wenn Fach wechselt, alle anderen Felder resetten
            if (this.aktuelleGruppe === null) {
                // @ts-ignore
                document.querySelector(`#kamodal-niveau`).tomselect.setValue('-');
                // @ts-ignore
                document.querySelector(`#kamodal-abschluss`).tomselect.setValue('-');
                // @ts-ignore
                document.querySelector(`#kamodal-testheft`).tomselect.setValue('-');
            }

            if ($(`#kamodal-fach`).val() !== '-') {
                // @ts-ignore
                document.querySelector(`#kamodal-niveau`).tomselect.enable();
                // @ts-ignore
                document.querySelector(`#kamodal-abschluss`).tomselect.enable();

                if (isVera5 || ['GY', 'RS'].includes(this._veraportal.sessionvariablen.schule.schulform)) {
                    this.refreshTestheftOptionen();
                }
            } else {
                // @ts-ignore
                document.querySelector(`#kamodal-niveau`).tomselect.disable();
                // @ts-ignore
                document.querySelector(`#kamodal-abschluss`).tomselect.disable();
                // @ts-ignore
                document.querySelector(`#kamodal-testheft`).tomselect.disable();
            }
        };

        const modalNiveauState = () => {
            const isVera5 = this._veraportal.sessionvariablen.projekt.weiche === 'vera5';

            // wenn Niveaustufe wechselt, alle anderen Felder resetten
            if (this.aktuelleGruppe === null) {
                // @ts-ignore
                document.querySelector(`#kamodal-abschluss`).tomselect.setValue('-');
            }
            if (isVera5 === false) {
                // @ts-ignore
                document.querySelector(`#kamodal-testheft`).tomselect.setValue('-');
            }

            if ((document.querySelector(`#kamodal-fach`) as HTMLInputElement).value !== '-') {
                if (
                    isVera5 ||
                    this._veraportal.sessionvariablen.schule.land !== 'nw' || // nur in NRW wird Kursschwierigkeit erhoben
                    (document.querySelector(`#kamodal-niveau`) as HTMLInputElement).value !== '-'
                ) {
                    this.refreshTestheftOptionen();
                } else {
                    // @ts-ignore
                    document.querySelector(`#kamodal-testheft`).tomselect.disable();
                }
            } else {
                // @ts-ignore
                document.querySelector(`#kamodal-testheft`).tomselect.disable();
            }
        };

        //region Tom-Select Initialisierungen
        try {
            // @ts-ignore
            let tsFach = new TomSelect(`#kamodal-fach`, {
                create: false,
                allowEmptyOption: true,
                controlInput: null,
                searchField: []
            });
            if (this.aktuelleGruppe !== null) {
                tsFach.setValue(this.aktuelleGruppe.kurs_fach);
                tsFach.disable();
            }

            // @ts-ignore
            let tsNiveau = new TomSelect(`#kamodal-niveau`, {
                create: false,
                allowEmptyOption: true,
                controlInput: null,
                searchField: []
            });
            if (this.aktuelleGruppe !== null) {
                tsNiveau.setValue(this.aktuelleGruppe.kurs_niveau);
            }

            // @ts-ignore
            let tsAbschluss = new TomSelect(`#kamodal-abschluss`, {
                create: false,
                allowEmptyOption: true,
                controlInput: null,
                searchField: []
            });
            if (this.aktuelleGruppe !== null) {
                tsAbschluss.setValue(this.aktuelleGruppe.kurs_abschluss);
            }

            // @ts-ignore
            new TomSelect(`#kamodal-testheft`, this._veraportal.tsTestheftOptions);
        } catch (e) {
            // Utilities.errorToSentry(e);
        }
        //endregion

        // Fach State-Check
        modalFachState();
        document.querySelector(`#kamodal-fach`).addEventListener('change', () => {
            modalFachState();
        });

        // Niveau State-Check
        modalNiveauState();

        document.querySelector(`#kamodal-niveau`).addEventListener('change', () => {
            modalNiveauState();
        });

        if (this.aktuelleGruppe !== null) {
            // Löschen-Button Klick-Event
            document.querySelector(`#kamodal-gruppe-loeschen-btn`).addEventListener('click', () => {
                let loeschenModal = new Modal(this._veraportal);
                let loeschenModalPromise = loeschenModal.show({
                    title: `Möchten Sie die Gruppe '${this.aktuelleGruppe.bezeichnung}' wirklich löschen?`,
                    body: `<p>Möchten Sie den Kurs '${this.aktuelleGruppe.bezeichnung}' wirklich löschen?</p>
                    <p>Nur Kurse ohne zugeordnete Schüler können gelöscht werden. Entfernen Sie zuerst alle Zuordnungen.</p>
                    <p>Um den Kurs wirklich zu löschen, geben Sie im Feld unten <i>"OK"</i> ein und betätigen Sie "Kurs löschen".</p>`,
                    hasSubmit: true,
                    hasCancel: true,
                    hasBestaetigung: true,
                    width: 700,
                    cancelText: 'Abbrechen',
                    submitText: 'Kurs löschen'
                });
                loeschenModalPromise.then(async (modalantwort) => {
                    if (modalantwort === true) {
                        try {
                            const api = VeraApi.getInstance(this._veraportal);
                            let deleteGruppeResponse = await api.deleteGruppe([{gruppe_id: this.aktuelleGruppe.gruppe_id ?? null}]);
                            if (deleteGruppeResponse === true) {
                                //TODO:medium Ansichten neu laden ohne kompleten Page-Reload
                                setTimeout(() => {
                                    window.location.reload();
                                }, 1000);
                            }
                        } catch (e) {
                            Utilities.errorToSentry(e);
                        }
                    }
                });
            });
        }

    }

    private refreshTestheftOptionen(): void {
        let niveau: string = (document.querySelector(`#kamodal-niveau`) as HTMLInputElement).value;

        // @ts-ignore
        document.querySelector(`#kamodal-testheft`).tomselect.destroy();
        document.querySelector(`#kamodal-testheft`).innerHTML =
            `<option value="-" ${
                (
                    this._veraportal.sessionvariablen.projekt.weiche !== 'vera5' &&
                    (this.aktuelleGruppe === null ||
                    (this._veraportal.sessionvariablen.schule.land === 'nw' && this.aktuelleGruppe?.kurs_niveau !== niveau)
                    )
                ) ? `selected` : ``
            }>Testheft wählen!</option>
            ${(Utilities.cloneObject(this._veraportal.testheftVarianten) as ITestheftvarianten[])
                .filter((t) => {
                    return t.fach === (document.querySelector(`#kamodal-fach`) as HTMLInputElement).value
                })
                .map((t: ITestheftvarianten) => {
                    //region über die normalen Testheftauswahlbestimmungen hinaus, gelten in Kursen zusätzliche Beschränkungen in NW
                    // im Hinblick auf Grundkurs und Erweiterungskurs, die im folgenden angewandt werden:
                    if (this._veraportal.sessionvariablen.schule.land === 'nw' && this._veraportal.sessionvariablen.projekt.weiche !== 'vera5') {
                        if (niveau === 'GK') {
                            if (this._veraportal.sessionvariablen.schule.schulform === 'RS') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                            }
                            if (this._veraportal.sessionvariablen.schule.schulform === 'HS') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                            }
                            if (this._veraportal.sessionvariablen.schule.schulform === 'GE') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                            }
                            if (this._veraportal.sessionvariablen.schule.schulform === 'FS') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                            }
                        }
                        if (niveau === 'EK') {
                            if (this._veraportal.sessionvariablen.schule.schulform === 'RS') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                            }
                            if (this._veraportal.sessionvariablen.schule.schulform === 'HS') {
                                if (t.fach === 'de') {
                                    if (t.schwierigkeit === 1) t.erlaubt = true;
                                    if (t.schwierigkeit === 2) t.erlaubt = false;
                                    if (t.schwierigkeit === 3) t.erlaubt = false;
                                    if (t.schwierigkeit === 1) t.erlaubt = false;
                                    if (t.schwierigkeit === 2) t.erlaubt = false;
                                } else {
                                    if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                    if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                                }

                            }
                            if (this._veraportal.sessionvariablen.schule.schulform === 'GE') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                            }
                            if (this._veraportal.sessionvariablen.schule.schulform === 'FS') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                            }
                        }
                        if (niveau === 'KD') {
                            if (this._veraportal.sessionvariablen.schule.schulform === 'RS') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                            }
                            if (this._veraportal.sessionvariablen.schule.schulform === 'HS') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                            }
                            if (this._veraportal.sessionvariablen.schule.schulform === 'GE') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                            }
                            if (this._veraportal.sessionvariablen.schule.schulform === 'FS') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                            }
                        }
                    }
                    //endregion

                    return t;
                })
                .map((v: ITestheftvarianten & { selected: boolean }) => {
                    // bisheriges Testheft auswählen, wenn Anpassungsmodus
                    if (this.aktuelleGruppe === null) {
                        v.selected = this._veraportal.sessionvariablen.projekt.weiche === 'vera5';
                    } else {
                        v.selected = this._veraportal.sessionvariablen.projekt.weiche === 'vera5' || (
                            (
                                (this._veraportal.sessionvariablen.schule.land === 'nw' && this.aktuelleGruppe?.kurs_niveau === niveau) ||
                                (this._veraportal.sessionvariablen.schule.land !== 'nw')
                            ) &&
                            (
                                (
                                    v.fach === 'ma' &&
                                    this.aktuelleGruppe.testheft_mathematik === v.testheft_id &&
                                    this.aktuelleGruppe.is_cbt_mathematik === ((v.cbt) ? 1 : 0)
                                ) ||
                                (
                                    v.fach === 'de' &&
                                    this.aktuelleGruppe.testheft_deutsch === v.testheft_id &&
                                    this.aktuelleGruppe.is_cbt_deutsch === ((v.cbt) ? 1 : 0)
                                ) ||
                                (
                                    v.fach === 'en' &&
                                    this.aktuelleGruppe.testheft_englisch === v.testheft_id &&
                                    this.aktuelleGruppe.is_cbt_englisch === ((v.cbt) ? 1 : 0)
                                ) ||
                                (
                                    v.fach === 'fr' &&
                                    this.aktuelleGruppe.testheft_franzoesisch === v.testheft_id &&
                                    this.aktuelleGruppe.is_cbt_franzoesisch === ((v.cbt) ? 1 : 0)
                                )
                            )
                        );
                    }
                    return v;
                })
                .map(this._veraportal.testheftOptionHTML).join('')}
            `;

        // @ts-ignore
        new TomSelect(`#kamodal-testheft`, this._veraportal.tsTestheftOptions);
        if (this._veraportal.sessionvariablen.projekt.weiche === 'vera5') {
            // @ts-ignore
            document.querySelector(`#kamodal-testheft`).tomselect.disable();
        } else {
            // @ts-ignore
            document.querySelector(`#kamodal-testheft`).tomselect.enable();
        }
    }

    override validation(): boolean {
        //region Gruppenbezeichnung prüfen
        if ((document.querySelector(`#kamodal-bezeichnung`) as HTMLInputElement).value.trim().length < 4) {
            let modal = new Modal(this._veraportal);
            modal.show({
                title: `Kursbezeichnung unzureichend`,
                body: `<p>Die Bezeichnung Ihres neuen Kurses muss mindestens vier Zeichen lang sein und darf keine Sonderzeichen enthalten.</p>`,
                hasSubmit: false,
                hasCancel: true,
                hasBestaetigung: false,
                width: 300,
                cancelText: 'OK'
            });
            return false;
        }
        //endregion

        //region Fach prüfen
        let fach = (document.querySelector(`#kamodal-fach`) as HTMLInputElement).value.trim() ?? '';
        if (['ma', 'de', 'en', 'fr'].includes(fach) === false) {
            let hinweisModal = new Modal(this._veraportal);
            hinweisModal.show({
                title: `Kein Fach ausgewählt`,
                body: `<p>Kurse sind immer fachspezifisch. Wählen Sie bitte das Fach für Ihren neu anzulegenden Kurs aus.</p>`,
                hasSubmit: false,
                hasCancel: true,
                hasBestaetigung: false,
                width: 200,
                cancelText: 'OK'
            });
            return false;
        }
        //endregion

        //region Niveau prüfen
        if (this._veraportal.sessionvariablen.schule.land === 'nw') {
            if (['GE', 'HS', 'FS'].includes(this._veraportal.sessionvariablen.schule.schulform)) {
                let niveau = (document.querySelector(`#kamodal-niveau`) as HTMLInputElement).value.trim() ?? '';
                if (['GK', 'EK', 'KD'].includes(niveau) === false) {
                    let hinweisModal = new Modal(this._veraportal);
                    hinweisModal.show({
                        title: `Kein Niveau ausgewählt`,
                        body: `<p>Wählen Sie bitte das Niveau in dem Ihr neuer Kurs unterrichtet wird.</p>`,
                        hasSubmit: false,
                        hasCancel: true,
                        hasBestaetigung: false,
                        width: 200,
                        cancelText: 'OK'
                    });
                    return false;
                }
            }
        }
        //endregion

        //region Testheftauswahl prüfen
        let testheft = (document.querySelector(`#kamodal-testheft`) as HTMLInputElement).value.trim() ?? '-';
        if (testheft === '-') {
            let hinweisModal = new Modal(this._veraportal);
            hinweisModal.show({
                title: `Kein Testheft ausgewählt`,
                body: `<p>In jedem Kurs muss ein Testheft ausgewählt werden, welches dann automatisch allen Schüler
                        zugewiesen wird, die diesem Kurs angehören.</p>`,
                hasSubmit: false,
                hasCancel: true,
                hasBestaetigung: false,
                width: 400,
                cancelText: 'OK'
            });
            return false;
        }
        //endregion

        return true;
    }

    protected antwortHandler(antwortPromise: Promise<any>): Promise<any> {
        antwortPromise.then(async (promiseValue) => {
            if (promiseValue !== true) return;

            let bezeichnung: string = (document.querySelector(`#kamodal-bezeichnung`) as HTMLInputElement).value.trim() ?? '';
            let fach: string = (document.querySelector(`#kamodal-fach`) as HTMLInputElement).value ?? '';
            let niveau: string = (document.querySelector(`#kamodal-niveau`) as HTMLInputElement).value.trim() ?? '';
            let abschluss: string = ((document.querySelector(`#kamodal-abschluss`) as HTMLInputElement).value.trim() !== '-') ? (document.querySelector(`#kamodal-abschluss`) as HTMLInputElement).value.trim() : null;
            let testheft: string = (document.querySelector(`#kamodal-testheft`) as HTMLInputElement).value.trim() ?? '-';

            let changedGruppenArr: IGruppenDB[] = [];
            changedGruppenArr.push({
                typ: 'KURS',
                gruppe_id: (this.aktuelleGruppe !== null) ? this.aktuelleGruppe.gruppe_id : null,
                bezeichnung: bezeichnung,
                kurs_fach: (fach as TFach),
                kurs_niveau: (niveau as TKursNiveau),
                kurs_abschluss: (abschluss as TKursAbschluss),
                testheft_mathematik: (fach === 'ma') ? parseInt(testheft) : null,
                testheft_deutsch: (fach === 'de') ? parseInt(testheft) : null,
                testheft_englisch: (fach === 'en') ? parseInt(testheft) : null,
                testheft_franzoesisch: (fach === 'fr') ? parseInt(testheft) : null,
                is_cbt_mathematik: (fach === 'ma' && testheft.indexOf('cbt') !== -1) ? 1 : 0,
                is_cbt_deutsch: (fach === 'de' && testheft.indexOf('cbt') !== -1) ? 1 : 0,
                is_cbt_englisch: (fach === 'en' && testheft.indexOf('cbt') !== -1) ? 1 : 0,
                is_cbt_franzoesisch: (fach === 'fr' && testheft.indexOf('cbt') !== -1) ? 1 : 0,
            });

            const api = VeraApi.getInstance(this._veraportal);
            await api.postGruppe(changedGruppenArr);

            //TODO:medium Ansichten neu laden ohne kompleten Page-Reload
            setTimeout(() => {
                window.location.reload();
            }, 1000);

        });
        return antwortPromise;
    }

}
